/** @format */
import { Link } from 'gatsby-plugin-intl';
import { rgba } from 'polished';
import styled from 'styled-components';
export const Ellipse = styled.span`
  display: inline-block;
  margin-bottom: 1px;
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.joivy.pink};
`;
export const RoomBoxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  border: 1px solid ${({ theme }) => rgba(theme.colors.joivy.white, 0.6)};
  width: 50%;
  @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
    width: 100%;
    height: 44px;
    min-height: auto;
  }
  background-color: ${({ theme }) => theme.colors.joivy.white};
`;
export const RoomBoxRoomNumber = styled.div`
  color: ${({ theme }) => theme.colors.joivy.pink};
  font-family: ${({ theme }) => theme.font.body};
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 220% */
`;
export const AvailableRoomTitle = styled.div`
  color: ${({ theme }) => theme.colors.joivy.black};
  font-family: ${({ theme }) => theme.font.body};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;
export const VisitLinkWrapper = styled.div`
  display: block;
  img {
    margin-right: 5px;
  }
`;
export const VisitLink = styled(Link)`
  display: inline-block;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.joivy.black};
  font-family: ${({ theme }) => theme.font.body};
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  height: 20px;
  text-underline-offset: 3px;
  text-decoration: underline;
  text-transform: capitalize;
`;
